import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  emoji: '🗓️',
  title: 'Sacrifici di fine settimana',
  desc: 'Sei stanco di rinunciare al sabato per preparare i laboratori e correggere il codice dei tuoi studenti.'
}, {
  emoji: '🌙',
  title: 'Serate senza fine',
  desc: 'Arrivi a casa esausto e devi ancora risolvere gli esercizi di Python per domani.'
}, {
  emoji: '💻',
  title: 'Alunni bloccati',
  desc: 'I tuoi studenti perdono motivazione davanti a una schermata nera e non riesci a coinvolgerli.'
}, {
  emoji: '📋',
  title: 'Programmazione di livello',
  desc: 'Vuoi presentare al Dirigente una programmazione moderna e in linea con le linee guida MIUR.'
}, {
  emoji: '🔄',
  title: 'Materiali sempre nuovi',
  desc: 'Cerchi schede e verifiche fresche senza ricominciare da capo ogni anno.'
}, {
  emoji: '⏱️',
  title: 'Tempo per la didattica',
  desc: 'Vuoi tornare a concentrarti su ciò che ami: insegnare e ispirare i tuoi studenti.'
}];
export function ForYouChecklist() {
  return <section className="py-10 px-4 bg-brand-card/40 border-y border-brand-orange/10" data-id="element-110">
      <div className="max-w-xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-112">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-113">
            Questa risorsa è per te se ti riconosci qui sotto.
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-114">
            Basta che uno solo di questi punti ti rappresenti.
          </p>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-115">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-brand-dark p-4 rounded-xl border border-white/5" data-id="element-116">
              <div className="text-3xl shrink-0" data-id="element-117">{item.emoji}</div>
              <div data-id="element-118">
                <h3 className="font-bold text-brand-cream mb-0.5" data-id="element-119">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-400 leading-snug" data-id="element-120">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-base font-bold text-brand-gold" data-id="element-121">
          ✓ Allora Programmazione Pronta è stato pensato esattamente per te.
        </p>
      </div>
    </section>;
}